require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-ravelijn-bridge.json") })
        }
      }, "path---projecten-ravelijn-bridge");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-ravelijn-bridge!./.cache/json/projecten-ravelijn-bridge.json
// module id = 438
// module chunks = 231608221292675